import React from "react"
import { Block } from "baseui/block"
import Common from "./Common"
import useAppContext from "~/hooks/useAppContext"
import { useActiveObject, useEditor } from "@agenteresolve/react"
import { useTranslation } from "react-i18next"

export default function () {
  const [state, setState] = React.useState({ fill: "#000000" })
  const { setActiveSubMenu } = useAppContext()
  const { t } = useTranslation("editor")
  const editor = useEditor()
  const activeObject = useActiveObject() as any

  React.useEffect(() => {
    if (editor) {
      setState({ fill: editor.canvas.backgroundColor as string })
    }
  }, [editor])

  React.useEffect(() => {
    let watcher = async () => {
      setState({ fill: editor.canvas.backgroundColor as string })
    }
    if (editor) {
      editor.on("canvas:updated", watcher)
    }
    return () => {
      if (editor) {
        editor.off("canvas:updated", watcher)
      }
    }
  }, [editor, activeObject])

  return (
    <Block $style={{ flex: 1, display: "flex", alignItems: "center", padding: "0 4px" }}>
      <button type="button" className="ar-toolstrip-control" onClick={() => setActiveSubMenu("CanvasFill")}>
        <span className="ar-color-swatch" style={{ background: state.fill }} />
        <span>{t("toolbox.background")}</span>
      </button>
    </Block>
  )
}
